import React, { useState, useEffect } from 'react';
import '../App.css'; // Add your styling if needed
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  p {
    font-size: 16px;
    text-align: left;
    margin-left: 10px;
  }
`;

function AdminPage() {
    const chromeMatch = navigator.userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
    if (chromeMatch) {
        const chromeVersion = parseInt(chromeMatch[1], 10); // Capture the version
        if (chromeVersion < 45) {
            ChromeSamples.setStatus('Нужно использовать Google Chrome версии не ниже 45.');
        }
    }

    var bluetoothDevice;
    let characteristic;
    let timeoutIDBLE;

    useEffect(() => {
        let isBluetoothAvailableLogged = false; // Track if the availability message has been logged
        try {
            navigator.bluetooth.getAvailability()
                .then(isBluetoothAvailable => {
                    if (!isBluetoothAvailableLogged) {
                        if (isBluetoothAvailable) {
                            log(`Bluetooth доступен`);
                        } else {
                            log('error', `Bluetooth недоступен`);
                        }
                        isBluetoothAvailableLogged = true; // Prevent duplicate logging
                    }
                });

            // Add event listener for availability changes
            if ('onavailabilitychanged' in navigator.bluetooth) {
                navigator.bluetooth.addEventListener('availabilitychanged', (event) => {
                    if (event.value) {
                        log(`Bluetooth доступен`);
                    } else {
                        log('error', `Bluetooth недоступен`);
                    }
                });
            }
        } catch (e) {
            log('error', "Ваш гаджет не поддерживает Bluetooth Low Energy");
        }
    }, []); // Run only once when the component mounts

    let serviceUuid = '0xFFE0';
    serviceUuid = parseInt(serviceUuid);
    let characteristicUuid = '0xFFE1';
    characteristicUuid = parseInt(characteristicUuid);
    let options = {
        filters: [{
            namePrefix: ["RealIoT"]
        }],
        optionalServices: [0xFFE0]
    };

    async function connectButton() {
        try {
            const device = await navigator.bluetooth.requestDevice(options);
            device.addEventListener('gattserverdisconnected', onDisconnected);
            const server = await device.gatt.connect();
            log('Жду ответа...');
            const service = await server.getPrimaryService(serviceUuid);
            characteristic = await service.getCharacteristic(characteristicUuid);
            characteristic.addEventListener('characteristicvaluechanged', handleNotification);
            await characteristic.startNotifications();
            log('Устанавливаем соединение');
            clearInterval(timeoutIDBLE);
        } catch (error) {
            log('error', error.message || error);
        }
    }

    function disconnect() {
        try {
            if (!bluetoothDevice) {
                return;
            }
            log('error', 'Связь потеряна...');
            if (bluetoothDevice.gatt.connected) {
                bluetoothDevice.gatt.disconnect();
                log('error', 'Ваш гаджет отключен от устройства');
            }
            let delay = 3; // sec
            timeoutIDBLE = setInterval(BLEconnect, delay * 1000);
        } catch (error) {
            log('error', error.message || error);
        }
    }

    function onDisconnected(event) {
        log('Bluetooth устройство отсоединено');
    }

    function handleNotification(event) {
        try {
            const value = event.target.value;
            if (value.byteLength >= 2) {
                const decoder = new TextDecoder('utf-8');
                const decodedString = decoder.decode(value);
                if (decodedString !== '') {
                    if (decodedString === 'OK' || decodedString === 'Соединение установлено') {
                        log('ok', `Ответ устройства: ${decodedString}`);
                    } else {
                        log('error', `Ответ устройства: ${decodedString}`);
                    }
                }
            }
        } catch (error) {
            log('error', error.message);
        }
    }

    function sendData() {
        try {
            let shortNumberValue = "";
            let shortNumber = document.getElementById("shortNumber").value;
            if (shortNumber === "") {
                log('error', `Введите короткое имя устройства`);
                return;
            } else if (shortNumber.length >= 7) {
                log('error', `Длина имени - не более 7 символов`);
                return;
            } else {
                shortNumberValue = shortNumber + "\r";
            }

            let SNValue = "";
            let SN = document.getElementById("SN").value;
            if (SN === "") {
                log('error', `Серийный номер не указан`);
                return;
            } else {
                SNValue = SN + "\r";
            }

            let emptyFieldValue = "";
            let emptyField = document.getElementById("emptyField").value;
            if (emptyField === "") {
                log(`Ничего писать сюда не надо`);
                return;
            } else {
                emptyFieldValue = "emptyField" + "\r";
            }

            let concatenatedString = "2," + shortNumberValue + "," + SNValue + "," + emptyFieldValue;
            let encoder = new TextEncoder('utf-8');
            let encodedString = encoder.encode(concatenatedString);
            if (!characteristic) {
                log('error', 'Нажмите "Подключиться".');
                return;
            } else {
                characteristic.writeValueWithResponse(encodedString);
            }
        } catch (error) {
            log('error', error.message);
        }
    }

    function log() {
        // Если нет аргументов, просто добавляем пустую строку
        if (!arguments.length) {
            document.querySelector('#log').textContent += '\n';
            return;
        }

        // Преобразуем arguments в массив
        const args = Array.prototype.slice.call(arguments);

        // Если первый аргумент равен "error" или "ok", считаем его статусом
        let status;
        if (args[0] === 'error' || args[0] === 'ok') {
            status = args.shift();
        } else {
            status = '';
        }

        const message = args
            .map(arg => (typeof arg === 'string' ? arg : JSON.stringify(arg)))
            .join(' ');

        let color = 'gray';
        if (status === 'error') {
            color = 'red';
        } else if (status === 'ok') {
            color = 'green';
        } else {
            color = 'gray';
        }

        document.querySelector('#log').innerHTML
            += `<div style="color: ${color};">${message}</div>`;
    }

    // ------------------- Рендеринг страницы -------------------
    return (
        <div>
            <GlobalStyle />
            <div>
                <h1>Страница администратора</h1>
                <div>
                    <h2>Установка имени и серийного номера устройства через Bluetooth Low Energy (BLE)</h2>
                    <p>1. Нажмите и отпустите кнопку включения Bluetooth на IoT устройстве и подождите около 15 сек, пока оно загрузится.</p>
                    <p>2. Включите Bluetooth на мобильном устройстве. Если используете настольный компьютер без BLE, то подключите внешний Bluetooth адаптер с версией Bluetooth не ниже 4.</p>
                    <button onClick={() => connectButton()}>
                        Подключиться
                    </button>
                    <p>3. В появившемся окне найдите маяк IoT устройства "RealIoT". Выберите его и нажмите "Pair". Если маяк не появился, нажмите кнопку сброса на IoT устройстве и подождите минуту, пока оно перезагрузится.</p>
                    <button onClick={() => disconnect()}>
                        Отключиться
                    </button>

                    <p style={{ marginBottom: '-5px' }}>Короткое имя устройства:</p>
                    <input type="text" id="shortNumber" name="inputField1" defaultValue="R1" />

                    <p style={{ marginBottom: '-5px' }}>Серийный номер:</p>
                    <input type="text" id="SN" name="inputField2" defaultValue="63OT-U501-BAQF-WPI5-5IL6" />

                    <p style={{ marginBottom: '-5px' }}>Временно пустое поле:</p>
                    <input type="text" id="emptyField" name="inputField3" defaultValue="empty" />

                    <p>3. Отправить данные можно только после того, как от IoT устройства придет сообщение, что соединение с ним установлено.</p>
                    <button onClick={() => sendData()}>
                        Отправить данные
                    </button>
                    <p>После подключения к WiFi устройство IoT автоматически отключает свой Bluetooth.</p>
                    <h3>Ответ устройства:</h3>
                    <div style={{ marginLeft: '5px', textAlign: 'left' }}>
                        <pre id="log"></pre>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminPage;
